<template>
  <div class="wrapper-main">
    <div class="banner-box"></div>
    <!-- <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1>
    <h1>About Page</h1> -->
    <BackTop />
  </div>
</template>

<script>
import BackTop from '@/components/BackTop.vue'
export default {
  name: 'About',
  components: {
    BackTop
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/about.less";
</style>
